import { render, staticRenderFns, recyclableRender, components } from "./u-sticky.vue?vue&type=template&id=c187ecf2&scoped=true&"
var renderjs
import script from "./u-sticky.vue?vue&type=script&lang=js&"
export * from "./u-sticky.vue?vue&type=script&lang=js&"
import style0 from "./u-sticky.vue?vue&type=style&index=0&id=c187ecf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c187ecf2",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-sticky/u-sticky.vue"
export default component.exports